import React from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import $ from 'jquery';
import { loadDealPayments } from '../store/deal.store';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';
import PaymentsContainer from './PaymentsContainer';
import RoleConfigFilter, { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { saveScrollPosition } from '@/store/scroll.store';
import { selectDealsPage } from '@/store/allaround.store';

export class PaymentsArea extends React.Component {
  constructor(props) {
    super(props);
    this.createPage = this.createPage.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.updatePagination = this.updatePagination.bind(this);
    this.renderPaginationPanel = this.renderPaginationPanel.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.dontScroll = false;
    this.initScroll = true;
    this.sizePerPage = null;
    this.state = { showDebit: true, showCredit: false };
  }

  componentWillMount() {
    this.props.loadDealPayments();
    this.createPage();
  }

  componentWillReceiveProps(props) {
    this.createPage(props);
    if (this.props.current == props.current && this.props.pageSize == props.pageSize) {
      this.dontScroll = true;
    } else {
      this.dontScroll = false;
    }
  }

  componentWillUpdate() {
    if (this.props.locationQuery) {
      this.updatePagination(this.props.locationQuery);
    }
  }

  componentDidUpdate() {
    if (!this.dontScroll || this.initScroll) {
      const scrollPosition = this.props.scrollPositions
        .get(`payments${this.props.current}`) || 0;
      window.scrollTo(0, scrollPosition);
      if (this.initScroll && document.body.clientHeight >= scrollPosition) {
        this.initScroll = false;
      }
    }
    $(window).ready(() => $('.table-pagesize-dropdown #pageDropDown').text(this.sizePerPage));
  }

  onPageChange(current, size) {
    this.props.saveScrollPosition(`payments${this.props.current}`);
    this.props.selectPage(current, size);
  }

  updatePagination(locationQuery) {
    if (locationQuery) {
      const pageNumber = parseInt(locationQuery.get('pageNumber', 1), 10);
      const pageSize = parseInt(locationQuery.get('pageSize', 100), 10);
      if (pageNumber && pageSize
        && (pageNumber != this.props.current || pageSize != this.props.pageSize)) {
        this.props.selectPage(pageNumber, pageSize);
      }
    }
  }

  createPage(props = this.props) {
    const lastAvailablePage = Math.ceil(props.payments.size / props.pageSize);
    const currentPage = props.current > lastAvailablePage ? lastAvailablePage : props.current;
    const data = props.payments.slice(currentPage * props.pageSize - props.pageSize,
      currentPage * props.pageSize);
    const pagination = true;
    this.setState({
      pagination,
      data,
    });
  }

  handleTabSelect(eventKey) {
    switch (parseInt(eventKey, 10)) {
      case 1: this.setState({ showDebit: true, showCredit: false }); break;
      case 2: this.setState({ showDebit: false, showCredit: true }); break;
      default: this.setState({ showDebit: false, showCredit: false }); break;
    }
  }

  renderPaginationPanel(props) {
    const { sizePerPage } = props;
    this.sizePerPage = sizePerPage;
    return (
      <div className="pagination-container" style={{ width: '40px', zIndex: '1000' }}>
        <div>{props.components.pageList}</div>
        <div className="table-pagesize-dropdown">{props.components.sizePerPageDropdown}</div>
      </div>
    );
  }

  render() {
    return (<div>
      <RoleConfigFilter permissions={['financesViewEditDelete', 'myPaymentsView', 'viewPayments']}>
        <div>
          <PaymentsContainer
            payments={this.props.payments}
            pageSize={this.props.pageSize}
            currentPage={this.props.current}
            onPageChange={this.onPageChange}
            pageSizeOptions={['25', '50', '100']}
            paginationPanel={this.renderPaginationPanel}
            showDebit={!this.props.isPlus}
            showCredit={this.props.isPlus}
            isClosed={this.props.isClosed}
            mode="financial"
            disabled={!validateRoleConfig(['financesViewEditDelete'])}
          />
        </div>
      </RoleConfigFilter>
    </div>);
  }
}

PaymentsArea.propTypes = {
  payments: React.PropTypes.object,
  loadDealPayments: React.PropTypes.func,
  scrollPositions: React.PropTypes.object,
  saveScrollPosition: React.PropTypes.func,
  current: React.PropTypes.number,
  pageSize: React.PropTypes.number,
  selectPage: React.PropTypes.func,
  roles: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]),
  locationQuery: React.PropTypes.object,
  isPlus: React.PropTypes.boolean,
  isClosed: React.PropTypes.boolean,
};

export default connect(
  (state) => ({
    payments: state.getIn(['data', 'deals', 'deal', 'payments'], new List()),
    scrollPositions: state.getIn(['scroll'], new Map()),
    pageSize: state.getIn(['allaround', 'dealsPageSize', 'payments'], 100),
    current: state.getIn(['allaround', 'dealsPage', 'payments'], 1),
    roles: state.getIn(['session', 'roles'], new List()),
    locationQuery: state.getIn(['routing', 'locationBeforeTransitions', 'query'], new Map()),
  }),
  (dispatch, props) => ({
    loadDealPayments() {
      loadDealPayments(dispatch);
    },
    selectPage(pageNumber, pageSize) {
      selectDealsPage(dispatch, pageNumber, pageSize, 'payments');
    },
    saveScrollPosition(page = `payments${props.current}`,
      location = window.pageYOffset ? window.pageYOffset : 0) {
      saveScrollPosition(dispatch, page, location);
    },
  })
)(PaymentsArea);
